export interface OrganizationRouter {
  goCreateUnit(search: string): void;
  goEditUnit(search: string): void;
  goToList(query?: string): void;
  goToPersonalDetail(userId: string, query?: string): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationRouter = Symbol('OrganizationRouter');
